import React from "react";
import useAppLayoutControl from "hooks/useAppLayoutControl";
import { OfferingVariationsList } from "./pages/OfferingVariationsList";
import { useOfferingVariations } from "./utils/hooks/useOfferingVariations";
import { useOfferingVariationListStore } from "./pages/OfferingVariationsList/store/useOfferingVariationList.store";
import { useMembershipStore } from "features/ManageOfferings/modules/MembershipsSection/store/useMembershipStore";

export const OfferingVariations = (props) => {
  useAppLayoutControl({ values: { showBottomNav: false } });
  const { match } = props;
  const offeringUuid = match.params.offeringUuid;
  const { provider } = useOfferingVariations({ offeringUuid });
  const { getListingDetails } = provider;
  const offeringUuidState = useOfferingVariationListStore(
    (state) => state.offeringUuid
  );
  const setOfferingUuid = useOfferingVariationListStore(
    (state) => state.setOfferingUuid
  );
  const setListingId = useMembershipStore((state) => state.setListingId);

  React.useEffect(() => {
    getListingDetails({ forceFetch: true });
  }, []);

  React.useEffect(() => {
    // setting offering id to the zustand when it changes i.e. when moving from one community to other
    if (!offeringUuidState || offeringUuidState != offeringUuid) {
      setOfferingUuid(offeringUuid);
      setListingId(offeringUuid);
    }
  }, [offeringUuid]);

  return <OfferingVariationsList {...props} />;
};
